module.exports = __webpack_public_path__ + "static/media/rewind-icon.70adba71.svg";